import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  standalone: true,
  selector: 'ui-icon-smartbnb',
  templateUrl: './icon-smartbnb.component.html',
  // eslint-disable-next-line @angular-eslint/component-max-inline-declarations
  styles: [
    `
      :host ::ng-deep .icon-platform-muted svg path {
        fill: var(--color-gray-400);
      }

      :host ::ng-deep .icon-platform-white svg path {
        fill: #fff;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class IconSmartbnbComponent {
  @Input() size = 16;
  @Input() white = false;
  @Input() muted = false;
}
